import last from 'lodash/last';
import escapeRegExp from 'lodash/escapeRegExp';

export function getAutosuggestQuery({ string = '', stopWords = [], minSymbolsToStart } = {}) {
  const startsRegex = new RegExp(`^${stopWords.join('|^')}`, 'i');
  const startWithStopWord = startsRegex.test(string);
  if (string && startWithStopWord) {
    // first rule cut stop word at the beginning
    // eslint-disable-next-line no-param-reassign
    string = last(string.split(startsRegex));
  }
  const stopWordsWithBothSpaces = stopWords.map((sw) => (sw !== '" ' ? ` ${sw}` : sw));
  const splitRegex = new RegExp(stopWordsWithBothSpaces.join('|'), 'g');
  // second rule cut stop words in the middle
  const query = last(string.split(splitRegex));
  return query && query.length >= minSymbolsToStart ? query : null;
}

export function replaceQueryWithSelected({ string = '', query, selected } = {}) {
  return query ? string.replace(new RegExp(`${escapeRegExp(query)}$`), selected) : '';
}

// Reverse-highlight
export function highlightQuery({ string = '', query } = {}) {
  return query ? string.replace(new RegExp(`(${escapeRegExp(query)})(.*)`, 'gi'), '$1<strong>$2</strong>') : string;
}

export function isFirstInGroup({ matches = [], index, groupBy } = {}) {
  const match = matches[index];
  const prevMatch = matches[index - 1];

  return !prevMatch || match[groupBy] !== prevMatch[groupBy];
}

export function calculateSelectedStartEnd({ string = '', selected }) {
  const start = string.lastIndexOf(selected);
  const end = start + selected.length;

  return { start, end };
}
